import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	min-width: 0;
	padding-right: 8px;
`;
